import type { User } from "./types";
import { appStorage, AppStorageKeys } from "@src/services/app-storage";

type MaybeUser = User | null;

const overlay = (incoming: User, prior: MaybeUser): User => {
  if (!prior) return incoming;
  return {
    ...incoming,
    email: incoming.email?.trim() || prior.email || "",
    name: incoming.name ?? prior.name,
    picture: incoming.picture ?? prior.picture,
  };
};

export const mergeUser = (incoming: MaybeUser, prior: MaybeUser): MaybeUser => {
  if (!incoming) return prior;
  return overlay(incoming, prior);
};

export const withCachedUser = (user: User): User =>
  mergeUser(user, appStorage.get<User>(AppStorageKeys.AUTH_USER)) ?? user;
